import { render, staticRenderFns } from "./SupplierEditTabInformation.vue?vue&type=template&id=4bf988db&scoped=true&"
import script from "./SupplierEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./SupplierEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./SupplierEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf988db",
  null
  
)

export default component.exports